import React from 'react'
import { Route, IndexRoute } from 'react-router'

import Posts from '../components/posts/list'
import CreatePost from '../components/posts/create'
import EditPost from '../components/posts/edit'

const PostRoutes = (
  <Route path='posts'>
    <IndexRoute component={Posts} />
    <Route path='create' component={CreatePost} />
    <Route path=':postId/edit' component={EditPost} />
  </Route>
)

export default PostRoutes
